export class SessionCustomerAddress {
    static readonly NO_ADDRESS_STR = "No Address Provided";

    address: string;
    additionalNotes:string
    lat: number;
    lng: number;

    /**
     * 
     * @param address 
     * @param additionalNotes 
     * @param latitude 
     * @param longitude 
     * @param isValid Used during checkout. We use this to check if the customer is within the delivery area of the restaurant or not
     */
    constructor(address: string, additionalNotes:string, latitude: number, longitude: number) {
        this.address      = address;
        this.additionalNotes = additionalNotes;
        this.lat             = latitude;
        this.lng             = longitude;
    }

    getAddressStr(){
        if(this.address != null && this.address != ""){
            return this.address;
        }else{
            return SessionCustomerAddress.NO_ADDRESS_STR;
        }
    }

    /** Generates a new SessionCustomerAddress. Either returns a full object or "undefined" */
    static newFromAws(awsAddressData:any):SessionCustomerAddress|undefined{
        if(awsAddressData!=null){
            return new SessionCustomerAddress(
                awsAddressData.address,
                awsAddressData.additionalNotes,
                awsAddressData.lat,
                awsAddressData.lng,
            );
        }else{
            return undefined;
        }
    }

    /** Converts this object into a format that can be saved on our database (DynamoDB) */
    toAwsObject(){
        const customerAddressObj = {
            "address":this.address,
            "additionalNotes":this.additionalNotes,
            "lat":this.lat,
            "lng":this.lng,
        }
        return customerAddressObj;
    }

    isAddressSet(){
        return this.lat!=null && this.lng!=null && this.address != null
    }
}